<template>
  <h1>Bienvenu ma chérie</h1>
</template>

<script setup lang="ts">

</script>